// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Hn-z","badgeLink":"In-z","category":"Jn-z"};